export function hideSignup() {
    const bookButton = document.querySelector('.button--book');
    const signupElement = document.querySelector('#signup');

    if (!bookButton || !signupElement) {
        console.error("Button or signup element not found.");
        return;
    }

    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Adjust padding (in pixels) for element visibility check
    const padding = 100; // Adjust this value as needed

    const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (
            rect.top < (window.innerHeight || document.documentElement.clientHeight) - padding &&
            rect.bottom > padding
        );
    };

    const handleScroll = () => {
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (isElementInViewport(signupElement)) {
            bookButton.style.opacity = '0';
            bookButton.style.visibility = 'hidden';
        } else {
            if (currentScrollTop < lastScrollTop) {
                bookButton.style.opacity = '1';
                bookButton.style.visibility = 'visible';
            } else {
                bookButton.style.opacity = '0';
                bookButton.style.visibility = 'hidden';
            }
        }

        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
    };

    document.addEventListener('scroll', handleScroll);

    bookButton.onclick = () => {
        bookButton.style.display = 'none';
    };
}
